/*(() => {
  // Get filenames from disabled swatches (e.g. 35585-PUFFERFISH_GOLD-l.jpg)
  const disabledFiles = new Set();

  document.querySelectorAll('variant-selects input.disabled[disabled]').forEach(input => {
    const label = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    const swatch = label?.querySelector('.swatch-color');
    const bg = swatch?.style?.getPropertyValue('--swatch-background') || '';
    const m = bg.match(/\/([^\/?]+)\?(.*)?$/); // grabs filename before ? or end
    if (m && m[1]) disabledFiles.add(m[1]);
  });

  console.log('Disabled swatch filenames:', [...disabledFiles]);

  let hidden = 0;
  document.querySelectorAll('.product__thumbs-item img').forEach(img => {
    const src = img.getAttribute('src') || '';
    const file = (src.match(/\/([^\/?]+)\?/ ) || src.match(/\/([^\/?]+)$/) || [])[1];
    if (file && disabledFiles.has(file)) {
      img.closest('.product__thumbs-item')?.style.setProperty('display', 'none', 'important');
      hidden++;
    }
  });

  console.log('Hidden thumbnails:', hidden);
})();*/


(() => {
  const decode = (s) => String(s || "").replace(/&amp;/g, "&");
  const getFile = (url) => decode(url).split("?")[0].split("/").pop() || "";

  const baseKey = (file) =>
    String(file || "").replace(
      /-l_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\.\w+$)/i,
      "-l"
    );

  const getSwatchUrl = (input) => {
    const label = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    const swatch = label?.querySelector(".swatch-color");
    const styleAttr = swatch?.getAttribute("style") || "";
    const bgVar = swatch?.style?.getPropertyValue("--swatch-background") || "";
    const m = (bgVar || styleAttr).match(/url\((['"]?)(.*?)\1\)/i);
    return m ? m[2] : "";
  };

  function run() {
    const root = document.querySelector("variant-selects");
    if (!root) return;

    const enabledFiles = new Set();
    const enabledBases = new Set();
    const disabledFiles = new Set();
    const disabledBases = new Set();

    root.querySelectorAll('input[type="radio"]').forEach((input) => {
      const file = getFile(getSwatchUrl(input));
      if (!file) return;

      const base = baseKey(file);
      const isDis = input.disabled || input.classList.contains("disabled");

      if (isDis) {
        disabledFiles.add(file);
        disabledBases.add(base);
      } else {
        enabledFiles.add(file);
        enabledBases.add(base);
      }
    });

    const thumbs = Array.from(document.querySelectorAll(".product__thumbs-item"));
    const groups = new Map();

    thumbs.forEach((item) => {
      const img = item.querySelector("img");
      const file = getFile(img?.getAttribute("src") || "");
      if (!file) return;

      const base = baseKey(file);

      // RULE A: hide disabled swatch thumbs (exact OR base match)
      if (disabledFiles.has(file) || disabledBases.has(base)) {
        item.style.setProperty("display", "none", "important");
        return;
      }

      // otherwise keep it (this preserves lifestyle images)
      item.style.removeProperty("display");

      // only dedupe "color-ish" items (ones that share a base with any swatch)
      // lifestyle images usually won't be in enabledBases, so they won't be deduped.
      if (enabledBases.has(base)) {
        if (!groups.has(base)) groups.set(base, []);
        groups.get(base).push({ item, file });
      }
    });

    // Dedupe only within swatch-known groups
    groups.forEach((items) => {
      if (items.length <= 1) return;
      const preferred = items.find((x) => enabledFiles.has(x.file));
      const keep = preferred || items[0];

      items.forEach((x) => {
        if (x !== keep) x.item.style.setProperty("display", "none", "important");
      });
    });
  }

  const rerun = () => {
    run();
    setTimeout(run, 50);
    setTimeout(run, 150);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", rerun);
  } else {
    rerun();
  }

  document.addEventListener(
    "change",
    (e) => {
      if (e.target.closest("variant-selects")) rerun();
    },
    true
  );

  const mo = new MutationObserver(rerun);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();




